import styled from 'styled-components';

export const CardConditionStyled = styled.div`
  .wrap-button {
    min-width: 110px;
  }
`;
